// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__aTuL9","colMin":"styles_colMin__2TcG3","colCheckbox":"styles_colCheckbox__2_0gT"};